import { createStore, applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas";
import { AuthActions, AuthSelectors, AuthTypes, AuthReducer } from "./auth.redux";
import {
  AttachmentActions,
  AttachmentSelectors,
  AttachmentTypes,
  reducer as AttachmentReducer,
} from "./attachment.redux";
import {
  ConversationActions,
  ConversationSelectors,
  ConversationTypes,
  ConversationReducer,
} from "./conversation.redux";
import { CallingActions, CallingSelectors, CallingTypes, CallingReducer } from "./calling.redux";
import { ContactActions, ContactSelectors, ContactTypes, ContactReducer } from "./contact.redux";
import { DeviceActions, DeviceSelectors, DeviceTypes, DeviceReducer } from "./device.redux";
import { GroupInfoActions, GroupInfoSelectors, GroupInfoTypes, GroupInfoReducer } from "./group-info.redux";
import { BranchActions, BranchSelectors, BranchTypes, BranchReducer } from "./branch.redux";
import { RestoreActions, RestoreSelectors, RestoreTypes, RestoreReducer } from "./restore.redux";
import { ProfileActions, ProfileSelectors, ProfileTypes, ProfileReducer } from "./profile.redux";
import { AccountActions, AccountSelectors, AccountTypes, AccountReducer } from "./account.redux";
import { SystemActions, SystemSelectors, SystemTypes, SystemReducer } from "./system.redux";
import { PubSubActions, PubSubTypes, PubSubReducer } from "./pubsub.redux";
import {
  NotificationSettingActions,
  NotificationSettingTypes,
  NotificationSettingSelectors,
  NotificationSettingReducer,
} from "./notification-setting.redux";
import thunk from "redux-thunk";
import { reducer as calling } from "../ring-rtc/state/ducks/calling";
import { reducer as user } from "../ring-rtc/state/ducks/user";
import { reducer as audioPlayer } from "../ring-rtc/state/ducks/audioPlayer";
import { reducer as app } from "../ring-rtc/state/ducks/app";
import { reducer as conversations } from "../ring-rtc/state/ducks/conversations";

/* ------------- Assemble The Reducers ------------- */
export const appReducer = combineReducers({
  authRedux: AuthReducer,
  conversationRedux: ConversationReducer,
  groupInfoRedux: GroupInfoReducer,
  contactRedux: ContactReducer,
  callingRedux: CallingReducer,
  deviceRedux: DeviceReducer,
  branchRedux: BranchReducer,
  restoreRedux: RestoreReducer,
  profileRedux: ProfileReducer,
  accountRedux: AccountReducer,
  systemRedux: SystemReducer,
  pubsubRedux: PubSubReducer,
  notificationSettingRedux: NotificationSettingReducer,
  attachmentRedux: AttachmentReducer,
  calling,
  user,
  audioPlayer,
  app,
  conversations,
});

export const rootReducer = (state, action) => {
  return appReducer(state, action);
};

/* ------------- Redux Configuration ------------- */

/* ------------- Saga Middleware ------------- */
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware];

// Create store
const store = createStore(rootReducer, applyMiddleware(...middlewares));

// kick off root saga
sagaMiddleware.run(rootSaga);

export const getReduxState = reducerFunc => reducerFunc(store.getState());

/* ------------- Export ------------- */
export {
  AuthActions,
  AuthTypes,
  AuthSelectors,
  ConversationActions,
  ConversationSelectors,
  ConversationTypes,
  GroupInfoActions,
  GroupInfoSelectors,
  GroupInfoTypes,
  CallingActions,
  CallingSelectors,
  CallingTypes,
  ContactActions,
  ContactSelectors,
  ContactTypes,
  DeviceActions,
  DeviceSelectors,
  DeviceTypes,
  BranchActions,
  BranchSelectors,
  BranchTypes,
  RestoreActions,
  RestoreSelectors,
  RestoreTypes,
  ProfileActions,
  ProfileSelectors,
  ProfileTypes,
  AccountActions,
  AccountSelectors,
  AccountTypes,
  SystemActions,
  SystemSelectors,
  SystemTypes,
  PubSubActions,
  PubSubTypes,
  NotificationSettingActions,
  NotificationSettingSelectors,
  NotificationSettingTypes,
  AttachmentActions,
  AttachmentSelectors,
  AttachmentTypes,
};

export default store;
